import { AxiosResponse } from 'axios';
import { useQuery } from '@tanstack/react-query';
import { API } from 'network/api';
import { MachineOwner } from './useMachineOwnerQuery';

const useMachineOwnerById = (id?: string, enabled = true) =>
  useQuery<AxiosResponse<MachineOwner>>({
    queryKey: ['machine-owner-by-id', id],
    queryFn: () => API.get(`/machine-owner/${id}`),
    enabled: !!id && enabled,
  });

export default useMachineOwnerById;
